var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._g(_vm._b({on:{"click":_vm.onClick}},'b-button',_vm.$props,false),_vm.listeners),[_c('span',{ref:"spSlot",staticStyle:{"display":"none"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }